import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconCommunicationCall16 } from '@cian/ui-kit-design-tokens/icons';

import { useCallbackButton } from './useCallbackButton';

export function BasicCallbackButton() {
  const [isAvailable, handleClick, isLoading] = useCallbackButton('blockJK');

  if (!isAvailable) {
    return null;
  }

  return (
    <Button
      theme="fill_white_primary"
      size={'M'}
      beforeIcon={<IconCommunicationCall16 color={'icon-main-default'} />}
      onClick={handleClick}
      loading={isLoading}
      aria-label="Заказ звонка"
      data-testid="BasicCallbackButton"
    />
  );
}
